﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import VeilederSlettingAvRenterDto from './Models/VeilederSlettingAvRenterDto';
import * as Ids from './Models/Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import { VeilederSlettingAvRenterAppState } from './Store/index';
import InfoboksComponent from './Components/InfoboksComponent';
import InntektOgBarnComponent from './Components/InntektOgBarnComponent';
import ResultatCaComponent from './Components/ResultatCaComponent';
import ResultatCbComponent from './Components/ResultatCbComponent';
import { SlettingAvRenterSatser } from './Utilities/SlettingAvRenterSatserApi';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

interface AppOwnProps {}
type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }
    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext, satser } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;
        
        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (resultat.visInntektOgBarn) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                }
            }

            if (!analyticsState.fullfort) {
                if (resultat.visResultatCa || resultat.visResultatCb) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                }
            }
        }

        if (epiContext.epiModelFeilet || resultat.visGenerellFeil) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {

            return (
                <div className="c-veileder">
                    {registerEvents()}
                    <InfoboksComponent
                        onChangeHandler = {(nyttValg: boolean): void => {
                            dispatchUpdateValg({ bInntektOgBarn: nyttValg });
                        }}
                        eventId={eventId}
                    />
                    {resultat.visInntektOgBarn && (
                        <InntektOgBarnComponent
                            locale = {locale}
                            onChangeHandler = {(inntekt: number, antallbarn: number): void => {
                                dispatchUpdateValg({ cInntekt: inntekt, cAntallBarn: antallbarn });
                            }}
                            sporsmalId = {Ids.BoksB}
                            valuta = {valuta}
                        />
                    )}
                    {resultat.visResultatCa && (
                        <ResultatCaComponent
                            satser = {satser}
                            valg = {valg}
                            valuta = {valuta}
                            eventId={eventId}
                        />
                    )}
                    {resultat.visResultatCb && (
                        <ResultatCbComponent
                            satser = {satser}
                            valg = {valg}
                            valuta = {valuta}
                            eventId={eventId}
                        />
                    )}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederSlettingAvRenterDto>;
    resultat: ResultatValg;
    satser: SlettingAvRenterSatser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (nyttValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (
    dispatch: ThunkDispatch<VeilederSlettingAvRenterAppState, {}, AnyAction>,
): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederSlettingAvRenterAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
